import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getFirstLinkedItemOrDefault, getSingleChoiceValue } from '@r-and-a-shared-ui/common-kontent-client/utils';
import { default as mapHeader } from './map-player_portals_header';
import { default as mapFooter } from './map-player_portals_footer';
import { hasValue } from '@r-and-a-shared-ui/utils';

export const player_portals_page_template = (entry: PLAYER_PORTALS_MODELS.PageTemplate) => {
  const headerKontentItem = getFirstLinkedItemOrDefault(
    entry?.elements?.header,
  ) as PLAYER_PORTALS_MODELS.Header;
  const footerKontentItem = getFirstLinkedItemOrDefault(
    entry?.elements?.footer,
  ) as PLAYER_PORTALS_MODELS.Footer;

  if(!hasValue(entry)) {
    return undefined;
  }

  return {
    templateSettings: {
      base_style: entry.system?.codename,
    },
    header: mapHeader(headerKontentItem),
    footer: mapFooter(footerKontentItem),
  };
};

export default player_portals_page_template;
